import _slicedToArray from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
function formatThousands(num) {
  if (num === 0) return '0';
  if (num === null || num === undefined) return '';
  var _num$toString$split = num.toString().split('.'),
    _num$toString$split2 = _slicedToArray(_num$toString$split, 2),
    integer = _num$toString$split2[0],
    decimal = _num$toString$split2[1];
  var formattedInt = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return decimal ? "".concat(formattedInt, ".").concat(decimal) : formattedInt;
}
export { formatThousands };